import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductCreditCardConfig } from '../@types/context/product-credit-card-config.types';
import type { ProductSecuredLoanConfig } from '../@types/context/product-secured-loan-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoNoConfig } from './presets/contact-axo-no.config';
import { creditCardNoConfig } from './presets/credit-card-no.config';
import { globalNo } from './presets/global-no.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { productConfigNo } from './presets/product-config.preset';
import { organisationAxoNoConfig } from './presets/organisation-axo-no.config';
import { securedLoanCaseConfig } from './presets/secured-loan-case.config';
import { securedLoanNoConfig } from './presets/secured-loan-no.config';
import { serviceTrustpilotAxoNoConfig } from './presets/service-trustpilot-axo-no.config';
import { sitePathGeminiNoConfig } from './presets/site-path-gemini-no.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansNoConfig } from './presets/unsecured-loans-no.config';

export const global: GlobalConfig = {
  brand: 'lendme.no',
  ...globalNo,
};

export const site: SiteConfig = {
  domain: 'lendme.no',
  name: 'LendMe',
  theme: {
    name: 'lendme',
    brand: 'lendme.axo',
  },
  ...sitePathGeminiNoConfig,
  ...organisationAxoNoConfig,
  ...contactAxoNoConfig,
  services: {
    trustpilot: { ...serviceTrustpilotAxoNoConfig, showInForms: true },
    gtm: 'GTM-KDXNWWC7',
    ga: 'G-21WCTRY01K',
    launchDarkly: {
      enabled: true,
      anonymousExperimentsEnabled: false,
    },
    cms: {
      provider: 'prepr',
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansNoConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const productSecuredLoan: ProductSecuredLoanConfig = {
  ...securedLoanNoConfig,
  ...securedLoanCaseConfig,
};

export const productCreditCard: ProductCreditCardConfig = {
  ...creditCardNoConfig,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    isCreditCardRecommendedVisible: false,
    creditCard: { hasApplyForm: true },
    ...myPageOffersConfig,
  },
};

export const product: ProductConfig = productConfigNo;
